export default __webpack_public_path__ + "054e53cd85bd6b993b265ade54849633.png";